export class ListaSelect {
    valor: number;
    descripcion: string;

    clear() {
        this.valor = undefined;
        this.descripcion = '';
	}
}
